module.exports = __webpack_public_path__ + "img/131.bd9f9c60.png";